import { useEffect, useState } from 'react';
import { TreatmentsClient } from './laboratoryClient';
export const useExperiment = experimentKey => {
  const [treatment, setTreatment] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    TreatmentsClient.resolve(treatments => {
      var _experimentTreatment$;
      const experimentTreatment = treatments === null || treatments === void 0 ? void 0 : treatments[experimentKey];
      const parameterValue = experimentTreatment === null || experimentTreatment === void 0 || (_experimentTreatment$ = experimentTreatment.parameters) === null || _experimentTreatment$ === void 0 ? void 0 : _experimentTreatment$.group;
      setTreatment(parameterValue || null);
      setIsLoading(false);
    });
  }, [experimentKey]);
  return {
    treatment,
    isLoading
  };
};